import React, { useState, useEffect } from 'react';
import { passkeyStepUpOptions, passkeyStepUpVerify } from '../services/api';
import { passkeyPrompt } from '../utils/passkeyPrompt';
import { assertPasskey, passkeysSupported, passkeyErrorMessage } from '../utils/webauthn';
import './ConfirmDeleteModal.css';
import './TwoFactor.css';

// Global passkey step-up (mounted once in App.js). A user-management action
// the server answered with 403 PASSKEY_REQUIRED waits here; the person taps
// their passkey, the API client retries the original request. An
// authenticator code is deliberately NOT an alternative here.
export default function PasskeyPromptModal() {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => passkeyPrompt.subscribe((isOpen) => {
    setOpen(isOpen);
    if (isOpen) { setError(''); setBusy(false); }
  }), []);

  if (!open) return null;

  const cancel = () => { if (!busy) passkeyPrompt.reject(); };

  const run = async () => {
    setBusy(true);
    setError('');
    try {
      const options = await passkeyStepUpOptions();
      const answer = await assertPasskey(options);
      await passkeyStepUpVerify(answer);
      passkeyPrompt.resolve();
    } catch (err) {
      setError(passkeyErrorMessage(err, 'get'));
      setBusy(false);
    }
  };

  const supported = passkeysSupported();
  return (
    <div className="modal-overlay tf-prompt-overlay" onClick={cancel}>
      <div className="modal-content" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Confirm with your passkey</h3>
          <button type="button" onClick={cancel} className="close-button" disabled={busy}>&times;</button>
        </div>
        <div className="modal-body" style={{ textAlign: 'left' }}>
          <p style={{ margin: '0 0 var(--spacing-sm)' }}>
            Adding, changing or removing a user needs your passkey — the device prompt (fingerprint, face, PIN or security key) appears when you press the button.
          </p>
          {!supported && <p className="tf-error" role="alert">This browser cannot use passkeys. Open the CRM in a current Chrome, Safari or Edge.</p>}
          {error && <p className="tf-error" role="alert">{error}</p>}
          <div className="tf-actions">
            <button type="button" className="btn btn-primary" onClick={run} disabled={busy || !supported}>{busy ? 'Waiting for your device…' : 'Use passkey'}</button>
            <button type="button" className="btn btn-outline" onClick={cancel} disabled={busy}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
}
